import { MenuItem as MenuItemType } from "@dirootie-web/elements-types";
import { NavLink, useLocation } from "react-router-dom";
import { map } from "ramda";
import { IconRT } from "../../../components-common/icons/Icon";
import { useWebRoute } from "../../../components-system/routing/use-routing.hook";
import { OverlayTooltip } from "../../../components-domain/generation-domain/specifications/OverlayTooltip";
import Tooltip from "react-bootstrap/Tooltip";

const MenuItem = ({
  to = "",
  id = to,
  icon,
  label,
  activeClass = "edb-icon-sidebar-active",
  inactiveClass = "",
}: MenuItemType) => {
  const replacedTo = useWebRoute(to);
  const { pathname } = useLocation();
  let isActive = false;

  if (label === "Dashboard") isActive = pathname === replacedTo;
  else isActive = pathname.includes(replacedTo);

  return (
    <NavLink
      to={replacedTo}
      key={id}
      className={isActive ? activeClass : inactiveClass}
      end={true}
      relative={"path"}
    >
      <OverlayTooltip
        component={() => (
          <Tooltip className="tooltip-button" style={{ position: "fixed" }}>
            {label}
          </Tooltip>
        )}
      >
        <button className="edb-icon-sidebar">
          <IconRT
            kind={icon as any}
            color="black"
          ></IconRT>
        </button>
      </OverlayTooltip>
    </NavLink>
  );
};

export const createMenuItems = (items: MenuItemType[]) =>
  map((x) => <MenuItem key={`menu-item-${x.id}`} {...x} />, items);
